/**
 * Designer — Shopify Product Page
 *
 * What this script does:
 *  1. Checks whether the product (or selected variant) has the designer_format metafield
 *  2. Replaces the "Add to Cart" button and hides "Buy it now"
 *  3. Opens the Designer as a modal (designer.html from assets)
 *  4. Receives DESIGN_PUSHED event → adds item with design metadata to the cart
 *
 * formatSource modes:
 *  - 'product': all variants share one format
 *  - 'variant': each variant has its own format → resolved from variantFormats on click
 */

(function () {
    'use strict';

    if (!window.DESIGNER_CONFIG?.format) {
        return;
    }

    const CFG = window.DESIGNER_CONFIG;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        const addToCartBtn = findAddToCartButton();
        if (addToCartBtn) {
            replaceButton(addToCartBtn);
        }

        const button = document.getElementById('designer-open-btn');
        if (!button) {
            console.log('#designer-open-btn not found, skipping Designer initialization');
            return;
        }

        button.style.setProperty('display', 'block', 'important');
        button.addEventListener('click', openModal);

        hideBuyItNow();
        injectModal();
        listenForDesignComplete();
    }

    // ── Find Add-to-Cart button ──────────────────────────────────────────────
    function findAddToCartButton() {
        const selectors = [
            'button[name="add"]',
            'button[type="submit"].product-form__submit',
            'button[type="submit"][data-add-to-cart]',
            'button[type="submit"][class*="add-to-cart"]',
        ];
        for (const s of selectors) {
            const el = document.querySelector(s);
            if (el) return el;
        }
        return null;
    }

    // ── Replace button ───────────────────────────────────────────────────────
    function replaceButton(original) {
        original.style.setProperty('display', 'none', 'important');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.id = 'designer-open-btn';
        btn.className = original.className;
        btn.textContent = 'Zum Designer →';
        btn.style.width = '100%';
        btn.addEventListener('click', openModal);

        original.parentNode.insertBefore(btn, original.nextSibling);
    }

    // ── Hide Buy it now ──────────────────────────────────────────────────────
    function hideBuyItNow() {
        const hide = () => [
            '[data-shopify="payment-button"]',
            '.shopify-payment-button',
            '[class*="dynamic-checkout"]',
        ].forEach(s => document.querySelectorAll(s)
            .forEach(el => el.style.setProperty('display', 'none', 'important')));

        hide();
        setTimeout(hide, 800);
        setTimeout(hide, 2000);
        new MutationObserver(hide).observe(document.body, {childList: true, subtree: true});
    }

    // ── Modal with iframe ────────────────────────────────────────────────────
    function injectModal() {
        document.head.insertAdjacentHTML('beforeend', `<style>
      #designer-overlay {
        display: none; position: fixed; inset: 0;
        background: rgba(0,0,0,.7); z-index: 99999;
        align-items: center; justify-content: center; padding: 12px;
      }
      #designer-overlay.open { display: flex; }
      #designer-modal {
        position: relative;
        background: #0f1117; border-radius: 10px;
        width: 100%; max-width: 1100px; height: 92vh;
        display: flex; flex-direction: column; overflow: hidden;
        box-shadow: 0 20px 60px rgba(0,0,0,.6);
        animation: designer-pop .2s cubic-bezier(.34,1.56,.64,1);
      }
      @keyframes designer-pop {
        from { opacity:0; transform:scale(.97) translateY(8px); }
        to   { opacity:1; transform:none; }
      }
      #designer-modal-header {
        display: flex; align-items: center; justify-content: space-between;
        padding: 10px 16px; border-bottom: 1px solid #2e3344; flex-shrink: 0;
        background: #1a1d27;
      }
      #designer-modal-header span {
        font-family: 'Fredoka', sans-serif;
        font-weight: 600; font-size: 20px;
        margin-right: auto; color: #e2e4ed
       }
      #designer-modal-close {
        width: 28px; height: 28px; background: #2e3344; border: none;
        border-radius: 50%; color: #e2e4ed; cursor: pointer; font-size: 14px;
        display: flex; align-items: center; justify-content: center;
        transition: background .13s;
      }
      #designer-modal-close:hover { background: #e74c5c; }
      #designer-frame { flex: 1; border: none; width: 100%; min-height: 0; }
      #designer-loading {
        position: absolute; inset: 0; top: 49px;
        background: #0f1117;
        display: flex; flex-direction: column;
        align-items: center; justify-content: center; gap: 16px;
        z-index: 1; border-radius: 0 0 10px 10px;
      }
      #designer-loading.hidden { display: none; }
      @keyframes designer-loading-spin {
        to { transform: rotate(360deg); }
      }
      #designer-loading .dl-spinner {
        width: 40px; height: 40px;
        border: 3px solid rgba(108,92,231,.25);
        border-top-color: #6c5ce7;
        border-radius: 50%;
        animation: designer-loading-spin .8s linear infinite;
      }
      #designer-loading .dl-label {
        font-family: 'Poppins', sans-serif;
        font-size: 13px; color: #8b8fa3;
      }
    </style>`);

        const modalTitle = CFG.product_title
            ? `Motiv für: ${CFG.product_title}`
            : 'Sticker Designer';

        document.body.insertAdjacentHTML('beforeend', `
      <div id="designer-overlay">
        <div id="designer-modal">
          <div id="designer-modal-header">
            <span>${modalTitle}</span>
            <button id="designer-modal-close" title="Schließen">✕</button>
          </div>
          <iframe id="designer-frame" src="about:blank" sandbox="allow-scripts allow-same-origin allow-downloads allow-popups allow-popups-to-escape-sandbox" title="Sticker Designer">
          </iframe>
          <div id="designer-loading" class="hidden">
            <div class="dl-spinner"></div>
            <span class="dl-label">Designer wird geladen…</span>
          </div>
        </div>
      </div>`);

        document.getElementById('designer-modal-close').addEventListener('click', closeModal);
        document.getElementById('designer-overlay').addEventListener('click', e => {
            if (e.target.id === 'designer-overlay') closeModal();
        });
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') closeModal();
        });
    }

    // ── Open modal ───────────────────────────────────────────────────────────
    function openModal() {
        const variationID = getCurrentlySelectedVariationID();
        if (!variationID) {
            alert('Bitte wähle zuerst eine Variation aus!');
            console.error('Keine Variation ausgewählt, Designer kann nicht fortfahren.');
            return;
        }

        let format = CFG.format;
        let dimension = CFG.dimension;

        if (CFG.formatSource === 'variant') {
            const variantFormat = CFG.variantFormats?.[variationID] ?? null;
            if (!variantFormat) {
                alert('Für diese Variation ist kein Format hinterlegt.');
                console.error('Kein designer_format für Variation', variationID);
                return;
            }
            const [w, h] = variantFormat.split('x').map(Number);
            format = variantFormat;
            dimension = { w, h };
        }

        const designerUrl = window._designerUrl || '/assets/sticker-designer.html';
        const params = new URLSearchParams({
            version: CFG.version || 0,
            format: format,
            format_w: dimension.w,
            format_h: dimension.h,
            shop: CFG.shop || '',
            variant_id: variationID,
            parent_origin: window.location.origin,
            asset_base_url: CFG.assetBaseUrl || '',
        });

        const frame = document.getElementById('designer-frame');
        const loading = document.getElementById('designer-loading');
        const sep = designerUrl.includes('?') ? '&' : '?';
        const url = `${designerUrl}${sep}${params.toString()}`;

        loading.classList.remove('hidden');

        frame.onload = function () {
            frame.contentWindow.postMessage(
                {type: 'DESIGNER_CONFIG', api_key: CFG.api_key || '', api_url: CFG.api_url || ''},
                '*'
            );
            loading.classList.add('hidden');
            frame.onload = null;
        };
        frame.src = url;

        document.getElementById('designer-overlay').classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    function getCurrentlySelectedVariationID() {
        // xo-theme: checked radio with explicit variant id
        return document.querySelector('input[type="radio"][xo-variant-id]:checked')?.getAttribute('xo-variant-id')
            // xo-theme: product element attribute
            || document.querySelector('xo-product[xo-selected-or-first-available-variant-id]')?.getAttribute('xo-selected-or-first-available-variant-id')
            // standard Shopify hidden input
            || document.querySelector('input[name="id"]')?.value
            || null;
    }

    // ── Close modal ──────────────────────────────────────────────────────────
    function closeModal() {
        document.getElementById('designer-overlay').classList.remove('open');
        document.body.style.overflow = '';
        // unload iframe so the designer stops running in the background
        setTimeout(() => {
            const overlay = document.getElementById('designer-overlay');
            if (!overlay.classList.contains('open')) {
                const frame = document.getElementById('designer-frame');
                frame.onload = null;
                frame.src = 'about:blank';
                document.getElementById('designer-loading').classList.add('hidden');
            }
        }, 300);
    }

    // ── postMessage listener ─────────────────────────────────────────────────
    function listenForDesignComplete() {
        window.addEventListener('message', function (e) {
            if (!e.data) return;

            if (e.data.type === 'DESIGN_PUSHED') {
                const formData = {
                    items: [
                        {
                            id: e.data.variant_id,
                            quantity: document.querySelector('input[name="quantity"]')?.value || 1,
                            properties: {
                                '_design_id': e.data.design_id,
                                '_design_url': e.data.image_url,
                                '_format': e.data.format,
                            },
                        }
                    ]
                };

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(formData)
                })
                    .then(response => response.json())
                    .then(() => {
                        closeModal();
                        fetch('/cart.js')
                            .then(response => response.json())
                            .then((response) => {
                                window.xoStore.set("xo-cart", (prev) => ({ ...prev, size: response.item_count }))("xo-cart/setCartSize");
                            });

                        //Disabled, since the cart sidebar is shown automatically
                        //showCartButton();
                    });
            }
        });
    }

    // ── Cart button ──────────────────────────────────────────────────────────
    function showCartButton() {
        if (document.getElementById('designer-cart-btn')) return;
        const designerBtn = document.getElementById('designer-open-btn');
        if (!designerBtn) return;

        const btn = document.createElement('a');
        btn.id        = 'designer-cart-btn';
        btn.href      = (window.Shopify?.routes?.root || '/') + 'cart';
        btn.className = designerBtn.className;
        btn.textContent = 'Zum Warenkorb →';
        btn.style.cssText = 'width:100%;margin-top:8px;text-align:center;text-decoration:none;';

        designerBtn.parentNode.insertBefore(btn, designerBtn.nextSibling);
    }

})();
